var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"title"},[_vm._v("Empty cart")]),_c('div',{staticClass:"subtitle-1"},[_vm._v("Start by adding items to your cart before continuing to checkout.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }